import { Options, Vue } from 'vue-class-component';
import { ApartmentDTO, ApartmentLabelDTO } from '@../../../client-generator/generated-clients/plants';
import { PropType } from 'vue';
import { sortApartmentLabels } from '@/core/utils/EntrancePlant/entrance-plant.utils';

@Options({
  name: 'ResidentItem',
  props: {
    apartment: {
      type: Object as PropType<ApartmentDTO>,
      required: false,
    },
    isBrfa: {
      type: Boolean,
      default: false,
    },
    isCallingCode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['apartment-selected'],
})
export default class ResidentItem extends Vue {
  apartment!: ApartmentDTO;
  isBrfa!: boolean;
  isCallingCode!: boolean;

  mounted(): void {}

  get firstLabel() {
    return sortApartmentLabels(this.apartment.labels)[0];
  }

  get othersLabels() {
    return sortApartmentLabels(this.apartment.labels).slice(1);
  }

  selected() {
    this.$emit('apartment-selected', this.apartment);
  }

  getLabelText(label?: ApartmentLabelDTO) {
    if (!label) {
      return '-';
    }
    if (this.isBrfa) {
      return this.apartment.code?.replaceAll('|', ' ');
    }

    if (this.isCallingCode) {
      let labelText = this.apartment.code ?? '';

      if (label.isPrivate && (label.surname || label.name)) {
        labelText += ` |`;
        labelText += ` ${label.surname ?? ''}`;
        labelText += ` ${label.name ?? ''}`;
      } else if (!label.isPrivate && (label.companyName || label.name)) {
        labelText += ` | ${[label.companyName, label.name].filter(Boolean).join(' ')}`;
      }

      return labelText;
    }

    if (label.isPrivate) {
      return `${label.surname ?? ''} ${label.name ?? ''}`;
    } else {
      return [label.companyName, label.name].filter(Boolean).join(' ');
    }
  }
}
